import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Users, X as XIcon } from 'lucide-react-native';
import { useTheme, SPACING, BORDER_RADIUS, TYPOGRAPHY } from '../../theme';
import { Card } from '@components/common';

interface RolesNudgeCardProps {
  onPickRoles: () => void;
  onDismiss: () => void;
}

export function RolesNudgeCard({ onPickRoles, onDismiss }: RolesNudgeCardProps) {
  const { colors } = useTheme();

  return (
    <Card variant="filled" padding="md" style={styles.rolesNudge}>
      <View style={styles.rolesNudgeRow}>
        <View style={[styles.rolesNudgeIcon, { backgroundColor: colors.primarySoft }]}>
          <Users size={20} color={colors.primary} />
        </View>
        <View style={styles.rolesNudgeText}>
          <Text style={[styles.rolesNudgeTitle, { color: colors.text }]}>
            Tell us what else you do
          </Text>
          <Text style={[styles.rolesNudgeBody, { color: colors.textSecondary }]}>
            REDI tailors lists and checklists to your roles. Add a few more.
          </Text>
        </View>
        <TouchableOpacity
          onPress={onDismiss}
          hitSlop={8}
          accessibilityRole="button"
          accessibilityLabel="Dismiss">
          <XIcon size={16} color={colors.textTertiary} />
        </TouchableOpacity>
      </View>
      <TouchableOpacity
        style={[styles.rolesNudgeBtn, { backgroundColor: colors.action }]}
        onPress={onPickRoles}
        accessibilityRole="button"
        accessibilityLabel="Pick your roles">
        <Text style={[styles.rolesNudgeBtnText, { color: colors.actionOn }]}>Pick roles</Text>
      </TouchableOpacity>
    </Card>
  );
}

const styles = StyleSheet.create({
  rolesNudge: {
    marginBottom: SPACING.md,
    gap: SPACING.smd,
  },
  rolesNudgeRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: SPACING.smd,
  },
  rolesNudgeIcon: {
    width: 40,
    height: 40,
    borderRadius: BORDER_RADIUS.md,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rolesNudgeText: {
    flex: 1,
  },
  rolesNudgeTitle: {
    ...TYPOGRAPHY.button,
    marginBottom: 2,
  },
  rolesNudgeBody: {
    ...TYPOGRAPHY.bodySmall,
    lineHeight: 17,
  },
  rolesNudgeBtn: {
    alignSelf: 'flex-start',
    paddingHorizontal: SPACING.md,
    paddingVertical: SPACING.xs,
    borderRadius: BORDER_RADIUS.full,
  },
  rolesNudgeBtnText: {
    ...TYPOGRAPHY.button,
  },
});
